import React from 'react'
import classNames from 'classnames'

export interface IDividerProps {
  className?: string
  orientation?: 'vertical' | 'horizontal'
  role?: 'separator'
  ariaOrientation?: 'horizontal' | 'vertical'
}

/**
 * An unsemantic visual divider. To use a semantic divider we can either update
 * this component to add an addition prop flag or just use an hr atg
 *
 * @param props
 * @returns
 */
export const Divider: React.FC<IDividerProps> = ({
  className,
  orientation = 'horizontal',
  role,
  ariaOrientation
}) => (
  <div
    className={classNames(
      'my-u-p--0 my-u-m--0',
      {
        'ds-u-border-top--1': orientation === 'horizontal',
        'my-u-width--full': orientation === 'horizontal',
        'ds-u-border-left--1': orientation === 'vertical'
      },
      className
    )}
    role={role}
    aria-orientation={ariaOrientation}
  />
)
